export default __webpack_public_path__ + "static/media/chauffage.3dbccba3.jpg";